import React from 'react';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { FiDollarSign } from 'react-icons/fi';
import api from '../config/api';
import { usePermissions } from '../context/PermissionsContext';
import ServicesFinancePanel from '../components/services/ServicesFinancePanel';
import { queryKeys, staleTimes } from '../config/queryKeys';
import './Services.css';

export default function ConsultantPayouts() {
  const { hasPermission } = usePermissions();
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') === 'invoices' ? 'invoices' : 'pay-run';

  const companies = useQuery(
    queryKeys.serviceCompanies,
    () => api.get('/services/companies').then((response) => response.data),
    { staleTime: staleTimes.reference }
  );

  return (
    <div className="services-page list-page">
      <div className="page-header">
        <div className="page-header-text">
          <h1>
            <FiDollarSign aria-hidden /> Consultant payouts
          </h1>
          <p className="page-subtitle">
            Operational pay-run ledger and payout invoice history (PAY-*). These records are not
            customer AR and do not post to the general ledger.
          </p>
        </div>
      </div>
      <ServicesFinancePanel
        canManage={hasPermission('service_finance_manage')}
        companies={companies.data || []}
        initialTab={initialTab}
        onTabChange={(tab) => {
          if (tab === 'invoices') {
            setSearchParams({ tab: 'invoices' }, { replace: true });
          } else {
            setSearchParams({}, { replace: true });
          }
        }}
      />
    </div>
  );
}
